'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassAvailable = exports.stringSeparatedWords = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _StarRating = require('components/StarRating/StarRating');

var _interpolate = require('helpers/interpolate');

var _deep = require('helpers/deep');

var _CountdownTimer = require('components/CountdownTimer/CountdownTimer');

var _OfferExpiryCountdown = require('./OfferExpiryCountdown');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stringSeparatedWords = exports.stringSeparatedWords = function stringSeparatedWords(separator) {
  for (var _len = arguments.length, words = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    words[_key - 1] = arguments[_key];
  }

  return (
    // remove all undefined words
    words.filter(Boolean)
    // combine all words using the seperator
    .join(separator)
  );
};

var ClassAvailable = exports.ClassAvailable = function (_PureComponent) {
  (0, _inherits3.default)(ClassAvailable, _PureComponent);

  function ClassAvailable() {
    (0, _classCallCheck3.default)(this, ClassAvailable);
    return (0, _possibleConstructorReturn3.default)(this, (ClassAvailable.__proto__ || (0, _getPrototypeOf2.default)(ClassAvailable)).apply(this, arguments));
  }

  (0, _createClass3.default)(ClassAvailable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ctaText = _props.ctaText,
          displayName = _props.displayName,
          legal = _props.legal,
          purchaseUrl = _props.purchaseUrl,
          schedule = _props.schedule,
          subtitle = _props.subtitle,
          title = _props.title;

      var venue = (0, _deep.deepExtract)('venue', schedule, {});
      var venueAddress = (0, _deep.deepExtract)('address', venue, {});
      var interpolationConfig = {
        $USER_NAME: displayName,
        $VENUE_NAME: (0, _deep.deepExtract)('name', venue, '')
      };
      var classStartTime = schedule.starttime * 1000;
      var promoTitle = (0, _interpolate.interpolate)(title, interpolationConfig);
      var promoSubtitle = (0, _interpolate.interpolate)(subtitle, interpolationConfig);
      var ratings = venue.ratings;
      var imageUrl = (0, _deep.deepExtract)('images.default', venue, undefined);
      var venueNameAndAlias = stringSeparatedWords(' • ', venue.name, (0, _deep.deepExtract)('location.name', venue));
      var classAdressLine1 = stringSeparatedWords(', ', venueAddress.address_line1, venueAddress.address_line2);
      var classAdressLine2 = stringSeparatedWords(', ', venueAddress.city, venueAddress.state, venueAddress.zip_code);
      var nextMidnightTime = (0, _CountdownTimer.nextMidnight)();
      var countdownTo = nextMidnightTime > classStartTime ? classStartTime : nextMidnightTime;
      return _react2.default.createElement(
        'section',
        { className: 'class-available' },
        _react2.default.createElement(
          'p',
          { className: 'class-available__mobile-title' },
          promoTitle
        ),
        _react2.default.createElement(
          'div',
          { className: 'class-available__class-detail' },
          _react2.default.createElement('img', { src: imageUrl, alt: 'venue' }),
          _react2.default.createElement(
            'div',
            { className: 'class-available__class-detail__content' },
            _react2.default.createElement(
              'h3',
              { className: 'epsilon mb-' },
              schedule.class.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'color-text-light mb' },
              venueNameAndAlias,
              _react2.default.createElement('br', null),
              !!ratings && _react2.default.createElement(_StarRating.StarRating, {
                rating: ratings.mean,
                showRatingNumber: true
              })
            ),
            _react2.default.createElement(
              'p',
              { className: 'color-text-light' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'inviteafriend.day-and-time',
                defaultMessage: '{classDay}, {classDate} at {classTime}',
                values: {
                  classDay: _react2.default.createElement(_reactIntl.FormattedDate, {
                    weekday: 'long',
                    value: classStartTime
                  }),
                  classDate: _react2.default.createElement(_reactIntl.FormattedDate, {
                    day: 'numeric',
                    month: 'short',
                    value: classStartTime
                  }),
                  classTime: _react2.default.createElement(_reactIntl.FormattedTime, {
                    value: classStartTime,
                    hour: 'numeric',
                    minute: 'numeric'
                  })
                }
              }),
              _react2.default.createElement('br', null),
              classAdressLine1,
              _react2.default.createElement('br', null),
              classAdressLine2
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'class-available__promo' },
          _react2.default.createElement(
            'div',
            { className: 'class-available__promo__offer' },
            _react2.default.createElement(
              'h2',
              { className: 'class-available__promo__offer__header mb' },
              promoTitle
            ),
            !!subtitle && _react2.default.createElement(
              'p',
              { className: 'class-available__promo__offer__subtitle' },
              promoSubtitle
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: purchaseUrl, className: 'class-available__promo__cta bt bt--primary mb-' },
              ctaText
            )
          ),
          !!legal && _react2.default.createElement(
            'p',
            { className: 'class-available__promo__legal color-text-light text--sm' },
            legal
          ),
          _react2.default.createElement(_OfferExpiryCountdown.OfferExpiryCountdown, { countdownTo: countdownTo })
        )
      );
    }
  }]);
  return ClassAvailable;
}(_react.PureComponent);

ClassAvailable.propTypes = {
  ctaText: _propTypes2.default.string.isRequired,
  displayName: _propTypes2.default.string.isRequired,
  legal: _propTypes2.default.string,
  purchaseUrl: _propTypes2.default.string.isRequired,
  schedule: _propTypes2.default.object,
  subtitle: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired
};